var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditText({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.843393 16C0.893388 16 0.943383 15.995 0.993378 15.9875L5.19796 15.25C5.24796 15.24 5.29545 15.2175 5.33045 15.18L15.9269 4.5825C15.9501 4.55937 15.9685 4.5319 15.981 4.50166C15.9935 4.47141 16 4.43899 16 4.40625C16 4.37351 15.9935 4.34109 15.981 4.31084C15.9685 4.2806 15.9501 4.25313 15.9269 4.23L11.7723 0.0725C11.7248 0.025 11.6623 0 11.5948 0C11.5273 0 11.4648 0.025 11.4173 0.0725L0.820895 10.67C0.783398 10.7075 0.760901 10.7525 0.750902 10.8025L0.013475 15.0075C-0.0108429 15.1414 -0.00215382 15.2793 0.0387898 15.4091C0.0797334 15.5389 0.151697 15.6568 0.248452 15.7525C0.413435 15.9125 0.620915 16 0.843393 16ZM2.52823 11.64L11.5948 2.575L13.4271 4.4075L4.36054 13.4725L2.13826 13.865L2.52823 11.64Z",
    fill: "#262641"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditText);
export default __webpack_public_path__ + "static/media/editText.2d0ad860b85b71f012d6243e867f3e87.svg";
export { ForwardRef as ReactComponent };